import { render, staticRenderFns } from "./aufgabe-erstellen-modal.vue?vue&type=template&id=1727f65f&scoped=true"
import script from "./aufgabe-erstellen-modal.vue?vue&type=script&lang=js"
export * from "./aufgabe-erstellen-modal.vue?vue&type=script&lang=js"
import style0 from "./aufgabe-erstellen-modal.vue?vue&type=style&index=0&id=1727f65f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1727f65f",
  null
  
)

export default component.exports